/**
 * ESG resource page ids (backend `EsgPages` enum string values).
 * Used on `summary-data/<fund_name>/<position_date>` as the `page_name` query
 * parameter so the API can select the response model for the requesting page.
 */
export const EsgPages = {
  PORTFOLIO_SUMMARY: 'portfolio-summary-page',
  ARTICLE_SCANNER: 'article-scanner-page',
  PRINCIPLE_ADVERSE_IMPACT: 'principle-adverse-impact-page',
  CARBON_EMISSIONS: 'carbon-emissions-page',
  ESG_EXPOSURE: 'esg-exposure-page',
  ESG: 'esg-page',
  ENVIRONMENTAL_ESG: 'environmental-esg-page',
  SOCIAL_ESG: 'social-esg-page',
  CORPORATE_GOVERNANCE_ESG: 'corporate-governance-esg-page',
} as const;

export type EsgPageKey = keyof typeof EsgPages;

export type EsgPageId = (typeof EsgPages)[EsgPageKey];
